module.exports = __webpack_public_path__ + "static/img/img22.b453458.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neighbourhood/img22.png
// module id = ENti
// module chunks = 1